<div [ngClass]="{ 'animate__animated animate__fadeIn animate__faster': !clippedBody() }">
  <!-- Optional fixed filter bar -->
  <div [ngClass]="{ 'position-fixed bg-white z-1 h-70px': clippedSearch() }">
    @if (filterEntities(); as filterEntities) {
      <list-filter
        class="me-4"
        [clippedSearch]="clippedSearch()"
        [inputValue]="filterEntities()"
        (updateFilter)="filterEntities.set($event.target.value)" />
    } @else {
      <list-filter
        class="me-4"
        [clippedSearch]="clippedSearch()"
        [inputValue]="searchValue.coreSignal()"
        (updateFilter)="searchValue.coreSignal.set($event.target.value)" />
    }
  </div>

  <!-- Header Label -->
  <div class="position-relative">
    <div class="position-absolute legend-like-header">
      <div class="font-4 primary-text-200 px-1">
        {{ label() }}
      </div>
    </div>
  </div>

  <!-- Body Container -->
  <div
    [class]="
      clippedBody() ? 'padding-1 h-100 clip4 primary-gradient-bg-100':
      'padding-1 pt-5 pb-3'
    ">
    <div
      [class]="
        clippedBody() ? 'clip4 h-100 user-card p-2 overflow-wrap':'p-2'
      ">
      <div class="d-flex flex-column py-2">
        <list-items
          (listItemClick)="selectEntity($event)"
          [entities]="displayEntities()"
          [template]="template()" />
      </div>
    </div>
  </div>
</div>
